// extracted by mini-css-extract-plugin
module.exports = {"toast":"notification_toast__3CD7G","toastBody":"notification_toastBody__3X01i"};